import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowLeftOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowLeftOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M20.115 11H7.055l5.72-8h-2.46l-6.43 9 6.43 9h2.46l-5.72-8h13.06v-2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowLeftOutlined;